export const MAX_SIZES_MB = {
  image: 20,
  video: 40,
  document: 5,
};

export const getFileCategory = (file: File): 'image' | 'video' | 'document' => {
  if (file.type.startsWith('image/')) return 'image';
  if (file.type.startsWith('video/')) return 'video';
  if (file.type.startsWith('audio/')) return 'video';
  return 'document';
};

export const isFileSizeValid = (file: File): { valid: boolean; category: string; max: number } => {
  const category = getFileCategory(file);
  const maxSizeMB = MAX_SIZES_MB[category];
  const sizeMB = file.size / (1024 * 1024);
  return {
    valid: sizeMB <= maxSizeMB,
    category,
    max: maxSizeMB,
  };
};